export function openIndexedDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('imageUploadDB', 1)

    request.onerror = (event) => {
      reject(`Erro opening Indexed DB: ${event}`)
    }

    request.onsuccess = (event) => {
      resolve((event.target as IDBRequest).result)
    }

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBRequest).result
      if (!db.objectStoreNames.contains('images')) {
        db.createObjectStore('images', { keyPath: 'id', autoIncrement: true })
      }
    }
  })
}
